import SingleSeriesExamples from './SingleSeries';
import MultiSeriesExamples from './MultiSeries';

export default [...SingleSeriesExamples, ...MultiSeriesExamples];
